// third-party
import { FormattedMessage } from "react-intl";

// assets
import { ReactComponent as Dashboard } from "assets/images/icons/btn_dashboard_light.svg";
import { ReactComponent as Dashboard_Select } from "assets/images/icons/btn_dashboard.svg";
import { ReactComponent as AInsight } from "assets/images/icons/btn_AInsight_light.svg";
import { ReactComponent as AInsight_Select } from "assets/images/icons/btn_AInsight.svg";
import { ReactComponent as Topology } from "assets/images/icons/btn_topology_light.svg";
import { ReactComponent as Topology_Select } from "assets/images/icons/btn_topology.svg";
import { ReactComponent as FloorPlan } from "assets/images/icons/btn_floorplan_light.svg";
import { ReactComponent as FloorPlan_Select } from "assets/images/icons/btn_floorplan.svg";
import { ReactComponent as Device } from "assets/images/icons/btn_device_light.svg";
import { ReactComponent as Device_Select } from "assets/images/icons/btn_device.svg";
import { ReactComponent as Client } from "assets/images/icons/btn_clients_light.svg";
import { ReactComponent as Client_Select } from "assets/images/icons/btn_clients.svg";
import { ReactComponent as Report } from "assets/images/icons/btn_report_light.svg";
import { ReactComponent as Report_Select } from "assets/images/icons/btn_report.svg";
import { ReactComponent as Monitor } from "assets/images/icons/btn_monitor_light.svg";
import { ReactComponent as Monitor_Select } from "assets/images/icons/btn_monitor.svg";
import { ReactComponent as Configuration } from "assets/images/icons/btn_configuration_light.svg";
import { ReactComponent as Configuration_Select } from "assets/images/icons/btn_configuration.svg";
import { ReactComponent as System } from "assets/images/icons/btn_system_light.svg";
import { ReactComponent as System_Select } from "assets/images/icons/btn_system.svg";
import { ReactComponent as WiFi_Planner } from "assets/images/icons/btn_wifi_planner_light.svg";
import { ReactComponent as WiFi_Planner_Select } from "assets/images/icons/btn_wifi_planner.svg";
import { ReactComponent as Alert } from "assets/images/icons/btn_alert_light.svg";
import { ReactComponent as Alert_Select } from "assets/images/icons/btn_alert.svg";
import { ReactComponent as Organizations } from "assets/images/icons/btn_organizations_light.svg";
import { ReactComponent as Organizations_Select } from "assets/images/icons/btn_organizations.svg";
import { ReactComponent as UserManagement } from "assets/images/icons/btn_account_light.svg";
import { ReactComponent as UserManagement_Select } from "assets/images/icons/btn_account.svg";
import { ReactComponent as Sites } from "assets/images/icons/btn_sites_light.svg";
import { ReactComponent as Sites_Select } from "assets/images/icons/btn_sites.svg";
import { ReactComponent as Accounts } from "assets/images/icons/btn_account_light.svg";
import { ReactComponent as Accounts_Select } from "assets/images/icons/btn_account.svg";
import { ReactComponent as ResourceCenter } from "assets/images/icons/btn_resource_center_light.svg";
import { ReactComponent as ResourceCenter_Select } from "assets/images/icons/btn_resource_center.svg";
import { ReactComponent as Support } from "assets/images/icons/btn_support_light.svg";
import { ReactComponent as Support_Select } from "assets/images/icons/btn_support.svg";
import { ReactComponent as LicenseManagement } from "assets/images/icons/btn_license_light.svg";
import { ReactComponent as LicenseManagement_Select } from "assets/images/icons/btn_license.svg";

// type

// icons
const icons = {
  Dashboard,
  Dashboard_Select,
  AInsight,
  AInsight_Select,
  Topology,
  Topology_Select,
  FloorPlan,
  FloorPlan_Select,
  Device,
  Device_Select,
  Client,
  Client_Select,
  Alert,
  Alert_Select,
  WiFi_Planner,
  WiFi_Planner_Select,
  Report,
  Report_Select,
  Monitor,
  Monitor_Select,
  Configuration,
  Configuration_Select,
  System,
  System_Select,
  Organizations,
  Organizations_Select,
  UserManagement,
  UserManagement_Select,
  Sites,
  Sites_Select,
  Accounts,
  Accounts_Select,
  ResourceCenter,
  ResourceCenter_Select,
  Support,
  Support_Select,
  LicenseManagement,
  LicenseManagement_Select,
};

// ==============================|| MENU ITEMS - PAGES ||============================== //

export const orgScopeSpecificItem = {
  id: "orgs-scope-pages",
  type: "group",
  children: [
    {
      id: "orgs-scope",
      title: <FormattedMessage id='orgs-scope' />,
      type: "item",
      url: "/msp/organizations",
      icon: icons.Organizations,
      iconSelect: icons.Organizations_Select,
    },
    {
      id: "users",
      title: <FormattedMessage id='users' />,
      type: "item",
      url: "/msp/users",
      icon: icons.Accounts,
      iconSelect: icons.Accounts_Select,
    },
    {
      id: "settings",
      title: <FormattedMessage id='settings' />,
      type: "item",
      url: "/msp/settings",
      icon: icons.System,
      iconSelect: icons.System_Select,
    },
    {
      id: "support",
      title: <FormattedMessage id='support' />,
      type: "item",
      url: "/msp/support",
      icon: icons.Support,
      iconSelect: icons.Support_Select,
    },
  ],
};

export const siteScopeSpecificItem = {
  id: "site-scope-pages",
  type: "group",
  children: [
    {
      id: "site-scope",
      title: <FormattedMessage id='site-scope' />,
      type: "item",
      url: "/org/sites",
      icon: icons.Sites,
      iconSelect: icons.Sites_Select,
    },
    {
      id: "devices",
      title: <FormattedMessage id='devices' />,
      type: "item",
      url: "/org/devices",
      icon: icons.Device,
      iconSelect: icons.Device_Select,
    },
    {
      id: "events",
      title: <FormattedMessage id='events' />,
      type: "item",
      url: "/org/events",
      icon: icons.Alert,
      iconSelect: icons.Alert_Select,
    },
    {
      id: "users",
      title: <FormattedMessage id='users' />,
      type: "item",
      url: "/org/users",
      icon: icons.Accounts,
      iconSelect: icons.Accounts_Select,
    },
    {
      id: "firmware-managements",
      title: <FormattedMessage id='firmware-managements' />,
      type: "item",
      url: "/org/firmware_managements",
      icon: icons.Configuration,
      iconSelect: icons.Configuration_Select,
    },
    {
      id: "license-management",
      title: <FormattedMessage id='license-management' />,
      type: "item",
      url: "/license",
      icon: icons.LicenseManagement,
      iconSelect: icons.LicenseManagement_Select,
    },
    {
      id: "settings",
      title: <FormattedMessage id='settings' />,
      type: "item",
      url: "/org/settings",
      icon: icons.System,
      iconSelect: icons.System_Select,
    },
    {
      id: "support",
      title: <FormattedMessage id='support' />,
      type: "item",
      url: "/org/support",
      icon: icons.Support,
      iconSelect: icons.Support_Select,
    },
  ],
};

export const pages = {
  id: "group-pages",
  /* title: <FormattedMessage id="pages" />, */
  type: "group",
  children: [
    {
      id: "dashboard",
      title: <FormattedMessage id='dashboard' />,
      type: "item",
      url: "/site/dashboard",
      icon: icons.Dashboard,
      iconSelect: icons.Dashboard_Select,
    },
    {
      id: "aInsight",
      title: <FormattedMessage id='aInsight' />,
      type: "item",
      url: "/site/AInsight",
      icon: icons.AInsight,
      iconSelect: icons.AInsight_Select,
    },
    {
      id: "topology",
      title: <FormattedMessage id='topology' />,
      type: "item",
      url: "/site/topology",
      icon: icons.Topology,
      iconSelect: icons.Topology_Select,
    },
    {
      id: "devices",
      title: <FormattedMessage id='devices' />,
      type: "item",
      url: "/site/devices",
      icon: icons.Device,
      iconSelect: icons.Device_Select,
    },
    {
      id: "wifiPlanner",
      title: <FormattedMessage id='wiFiPlanner' />,
      type: "item",
      url: "/site/wifiPlanner",
      icon: icons.WiFi_Planner,
      iconSelect: icons.WiFi_Planner_Select,
      permissions: ["Admin", "Super Admin"],
    },
    {
      id: "events",
      title: <FormattedMessage id='events' />,
      type: "item",
      url: "/site/events",
      icon: icons.Alert,
      iconSelect: icons.Alert_Select,
    },
    {
      id: "clients",
      title: <FormattedMessage id='clients' />,
      type: "item",
      url: "/clients",
      icon: icons.Client,
      iconSelect: icons.Client_Select,
    },
    {
      id: "firmware-managements",
      title: <FormattedMessage id='firmware-managements' />,
      type: "item",
      url: "/site/firmware_managements",
      icon: icons.Configuration,
      iconSelect: icons.Configuration_Select,
    },
    {
      id: "settings",
      title: <FormattedMessage id='settings' />,
      type: "item",
      url: "/site/settings",
      icon: icons.System,
      iconSelect: icons.System_Select,
    },
    {
      id: "support",
      title: <FormattedMessage id='support' />,
      type: "item",
      url: "/site/support",
      icon: icons.Support,
      iconSelect: icons.Support_Select,
    },
  ],
};
